export const EVENT_CLOSE = 'close';
